
pushModeUrlConverterRun.$inject = ['$rootScope', 'UserFactory', '$state']
export function pushModeUrlConverterRun($rootScope, UserFactory, $state) {
  $rootScope.$on('$stateChangeSuccess',
    function(event, toState, toParams, fromState, fromParams) {
        let loggedUser = UserFactory.getLoggedUser();
        if (loggedUser.is_in_push_mode) {
          if (toState.name.match(/auth\.alcmeon\..*\.list\.tasks$/)) {
            $state.go('auth.alcmeon.pushbox');
          }
          else if (toState.name.match(/auth\.alcmeon\..*\.list\.tasks.process$/)) {
            $state.go('auth.alcmeon.pushbox.process', toParams);
          }
        }
    }
  )
}
